<template>
  <div class="jl-auc_add-address">
    <div class="shadow" @click="closeModal"></div>
    <div class="add-form">
      <div class="add-form-top">
        <h2>{{editData.id?'修改收货信息':'新增收货信息'}}</h2>
        <div class="add-form-close" @click="closeModal"></div>
        <div class="add-form-contetn">
          <div class="form-ground">
            <label class="form-label" for>收货人</label>
            <div class="form-ground-box">
              <input
                class="form-input"
                v-model.trim="form.consignee.value"
                type="text"
                placeholder="请输入收货人姓名"
                @blur="checkItemInput('consignee')"
              />
              <div v-if="form.consignee.isError" class="form-error">请输入收货人姓名</div>
            </div>
          </div>
          <div class="form-ground">
            <label class="form-label" for>手机号码</label>
            <div class="form-ground-box">
              <input
                class="form-input"
                v-model.trim="form.contactPhone.value"
                type="text"
                placeholder="请输入收货人手机号码"
                @blur="checkItemInput('contactPhone')"
              />
              <div
                v-if="form.contactPhone.isError"
                class="form-error"
              >{{form.contactPhone.errorText}}</div>
            </div>
          </div>
          <div class="form-ground">
            <label class="form-label" for>收货地址</label>
            <div class="form-ground-box">
              <input
                class="form-input"
                v-model.trim="form.shippingAddress.value"
                type="text"
                placeholder="请输入收货地址"
                @blur="checkItemInput('shippingAddress')"
              />
              <div v-if="form.shippingAddress.isError" class="form-error">请输入收货地址</div>
            </div>
          </div>
          <div class="form-ground">
            <label class="form-label" for>邮编</label>
            <div class="form-ground-box">
              <input
                class="form-input"
                v-model.trim="form.zipCode.value"
                type="text"
                placeholder="请输入6位邮编"
                @blur="checkItemInput('zipCode')"
              />
              <div v-if="form.zipCode.isError" class="form-error">{{form.zipCode.errorText}}</div>
            </div>
          </div>
          <div class="form-ground">
            <div class="form-check">
              <input
                id="color-input-red"
                class="chat-button-location-radio-input"
                type="checkbox"
                name="color-input-red"
                v-model="checkVal"
                @change="changeCheckVal"
              />
              <label for="color-input-red"></label>
              <span class="span-check">设为默认地址</span>
            </div>
          </div>
        </div>
      </div>
      <div class="add-form-bottom">
        <button class="btn" @click="closeModal">取消</button>
        <button class="btn confim" @click="submit">
          确定
          <span class="jl-loading" v-if="isLoading">
            <i class="jl-icon-loading"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { add_updata_Address } from "@/api/shop";
import { mapGetters } from "vuex";
export default {
  props: {
    editData: [Object, String]
  },
  data() {
    return {
      checkVal: "",
      form: {
        consignee: {
          value: "",
          isError: false
        },
        contactPhone: {
          value: "",
          isError: false,
          errorText: "",
          text1: "请输入手机号码",
          text2: "手机号码格式不正确"
        },
        shippingAddress: {
          value: "",
          isError: false
        },
        zipCode: {
          value: "",
          isError: false,
          errorText: "",
          text1: "请输入邮编",
          text2: "邮编格式不正确"
        }
      },
      id: "",
      isLoading: false
    };
  },
  created() {
    this.id = this.editData.id;
    this.form.consignee.value = this.editData.consignee;
    this.form.contactPhone.value = this.editData.contactPhone;
    this.form.shippingAddress.value = this.editData.shippingAddress;
    this.form.zipCode.value = this.editData.zipCode;
    this.checkVal = this.editData.isDefault === 0 ? true : false;
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    changeCheckVal() {
      console.log(this.checkVal);
    },
    closeModal() {
      this.$emit("closeAddAddress");
    },
    //检查是否填写完整
    checkInput() {
      let arr = Object.keys(this.form),
        data = [];
      for (const key of arr) {
        this.checkItemInput(key);
      }
      for (const key of arr) {
        if (!this.form[key].isError) {
          data.push(true);
        } else {
          data.push(false);
        }
      }
      if (data.indexOf(false) > -1) {
        return false;
      } else {
        return true;
      }
    },
    checkItemInput(key) {
      if (key === "zipCode") {
        let reg = /^[1-9]\d{5}(?!\d)$/;
        if (!this.form[key].value) {
          this.form[key].isError = true;
          this.form[key].errorText = this.form[key].text1;
        } else {
          if (!reg.test(this.form[key].value)) {
            this.form[key].isError = true;
            this.form[key].errorText = this.form[key].text2;
          } else {
            this.form[key].isError = false;
            this.form[key].errorText = "";
          }
        }
      } else if (key === "contactPhone") {
        let regPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
        if (!this.form[key].value) {
          this.form[key].isError = true;
          this.form[key].errorText = this.form[key].text1;
        } else {
          if (!regPhone.test(this.form[key].value)) {
            this.form[key].isError = true;
            this.form[key].errorText = this.form[key].text2;
          } else {
            this.form[key].isError = false;
            this.form[key].errorText = "";
          }
        }
      } else {
        this.form[key].isError = this.form[key].value ? false : true;
      }
    },
    // 提交收货地址
    submit() {
      let check = this.checkInput(),
        text = this.id ? "修改失败" : "添加失败",
        text2 = this.id ? "修改成功" : "添加成功";
      if (!check) return;
      this.isLoading = true;
      let data = {
        name: this.form.consignee.value,
        phone: this.form.contactPhone.value,
        address: this.form.shippingAddress.value,
        zipCode: this.form.zipCode.value,
        isDefault: this.checkVal ? 0 : 1
      };
      add_updata_Address(this, res => {
        this.isLoading = false;
        if (res.code == 200) {
          this.$notify({
            title: "提示",
            message: text2,
            type: "success"
          });
          this.$emit("addList");
        } else {
          this.$notify({
            title: "提示",
            message: text,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc_add-address {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  .shadow {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.7);
  }
  .add-form {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 576px;
    height: 456px;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 10;
  }
  .add-form-top {
    position: relative;
    padding: 26px 49px 0 49px;
    .add-form-close {
      position: absolute;
      right: 30px;
      top: 30px;
      width: 16px;
      height: 16px;
      background: url("../assets/img/zkj-address-close.png") no-repeat center
        center;
      cursor: pointer;
    }
    h2 {
      font-size: 20px;
      color: #333;
    }
  }
  .add-form-contetn {
    padding-top: 28px;
  }
  .form-ground {
    position: relative;
    padding-left: 76px;
    margin-bottom: 20px;
    .form-label {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      color: #333;
    }
    .form-input {
      display: block;
      width: 100%;
      height: 42px;
      line-height: 42px;
      padding-left: 26px;
      border: 1px solid #ccc;
      font-size: 14px;
    }
  }
  .form-ground-box {
    position: relative;
  }
  .form-error {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    margin-top: 5px;
    font-size: 12px;
    color: #e81727;
    line-height: 1;
    padding-left: 20px;
    background: url("../assets/img/zkj-form-tips.png") no-repeat left center;
    background-size: 12px;
  }
  .add-form-bottom {
    padding: 20px 0;
    border-top: 1px solid #e0e0e0;
    text-align: center;
    .btn {
      width: 100px;
      height: 42px;
      font-size: 16px;
      color: #333;
      border: 1px solid #666;
      line-height: 42px;
      text-align: center;
      margin: 0 10px;
      background: transparent;
      cursor: pointer;
      outline: none;
      &.confim {
        color: #fff;
        background: #e81727;
        border-color: #e81727;
      }
    }
  }
}
.form-check {
  position: relative;
  padding-left: 25px;
}
.span-check {
  font-size: 14px;
  color: #333;
}
#color-input-red {
  position: absolute;
  z-index: -200;
  visibility: hidden;
}
#color-input-red + label {
  display: block;
  width: 14px;
  height: 14px;
  cursor: pointer;
  position: absolute;
  top: 2px;
  left: 0;
  background: transparent;
  border: 1px solid #a8a8a8;
}
#color-input-red:checked + label {
  background: #e81727;
  border-color: #e81727;
}
#color-input-red:checked + label::before {
  content: "\2714";
  display: block;
  text-align: center;
  font-size: 12px;
  color: #fff;
}
</style>
